<template>
  <div class="row">
    <div class="col-xl-4 col-lg-5 col-md-6">
      <user-card> </user-card>
    </div>
    <div class="col-xl-8 col-lg-7 col-md-6">
      <edit-profile-form> </edit-profile-form>
    </div>
    <div class="col-xl-4 col-lg-5 col-md-6">
    </div>
    <div v-if="userRole === 'admin'" class="col-xl-8 col-lg-7 col-md-6" :key="'admin-members'">
      <members-card></members-card>
    </div>

  </div>
</template>
<script>
import EditProfileForm from "@/components/shared/EditProfileForm.vue";
import MembersCard from "@/views/patrimoine/client/MembersCard.vue";
import UserCard from "@/components/shared/UserCard.vue";
import { getUserRole, refreshProfileFromApi } from "@/utils/auth";

export default {
  components: {
    EditProfileForm,
    UserCard,
    MembersCard,
  },
  data() {
    return {
      profileRevision: 0,
    };
  },
  computed: {
    userRole() {
      void this.profileRevision;
      return getUserRole() || "";
    },
  },
  async mounted() {
    await refreshProfileFromApi();
    this.profileRevision += 1;
  },
};
</script>
<style></style>
